module.exports = __webpack_public_path__ + "static/media/light.78d46b5c.png";